var addEvent = function(e, t, n) {
    if (e == null || e == undefined) return;
    if (e.addEventListener) {
        e.addEventListener(t, n, false)
    } else if (e.attachEvent) {
        e.attachEvent("on" + t, n)
    }
};
var removeEvent = function(elem, type, eventHandle) {
    if (elem == null || elem == undefined) return;
    if (elem.removeEventListener) {
        elem.removeEventListener(type, eventHandle, false);
    } else if (elem.attachEvent) {
        elem.detachEvent("on" + type, eventHandle);
    }
};
var waitForFinalEvent = (function() {
    var timers = {};
    return function(callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();

const styles = ['font-size: 14px', 'color: #ffffff', 'background-color: #7FA113', 'padding: 4px 0px 4px 8px'].join(';')
    , brandStyles = ['font-size: 14px', 'color: #ffffff', 'background-color: #293133', 'padding: 4px 8px 4px 8px', 'font-weight: bold'].join(';')
    , text = '%cMade by %cW3design https://www.w3design.it/';
console.log(text, styles, brandStyles);

addEvent(window, "load", function() {

});
addEvent(window, "resize", function() {
    /*waitForFinalEvent(function(){
        alert('Resize...');
        //...
    }, 500, "some unique string");*/
});

if($("#contact-form").length>0) {
    $("#contact-form form").validate({
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                email: true
            },
            privacy: {
                required: true
            },
        },
        /*messages: {
            first_name: "Campo obbligatorio",
            last_name: "Campo obbligatorio",
            email: "Campo obbligatorio",
            privacy: "Campo obbligatorio",
        }*/
        errorPlacement: function(error, element) {
            if (element.attr("name") == "privacy" )
            {
                error.appendTo("#error_privacy");
            } else {
                error.insertAfter(element)
            }
        }
    });
}

$(window).scroll(function() {
    if ($(this).scrollTop() > 350) {
        $('.scroll-top').fadeIn();
    }else{
        $('.scroll-top').fadeOut();
    }
});


$('.scroll-top').click(function (e) {
    e.preventDefault();
    $("html, body").animate({scrollTop:0}, 'slow');
})

$('.hamburger').click(function() {
    $(this).toggleClass("is-active");
    $('.navigation').toggleClass("open");
});

/* toogle submenu */
$(document).on('click','.has-submenu > a', function (e){
    e.preventDefault();
    $('.submenu').toggleClass('open');
});
$(document).on('click', function (e) {
    if (!$(e.target).closest('header').length) {
        $('.submenu').removeClass('open');
    }
});
/* toogle submenu */

if($("#info-msg").length>0) {
    $('#info-msg').show(function () {
        $(".chiudi").click(function(e){
            e.preventDefault();
            $('#info-msg').hide();
            $('.overlay-popup').hide();
        })
    });
}

$('.owl-brand').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    dots:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:5
        }
    }
})

$('.owl-referenza').owlCarousel({
    loop:false,
    margin:30,
    nav:false,
    dots:true,
    responsive:{
        0:{
            items:1,
            dots:true
        },
        600:{
            items:3,
            dots:true,
            slideBy:3
        }
    }
})

$('.reference-carousel').owlCarousel({
    loop:false,
    margin:30,
    nav:false,
    dots:true,
    responsive:{
        0:{
            items:1,
            dots:true
        },
        600:{
            items:3,
            dots:true,
            slideBy:3
        }
    }
})
